module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/sliders/slider-style1/slider-style1.component.scss
// module id = ./src/app/sliders/slider-style1/slider-style1.component.scss
// module chunks = main